export default __webpack_public_path__ + "static/targeting-options-dark-mode-99e3bab484628f848d3963d94315d771.png";